// PROMPT 152: avisos push de ESTE navegador (service worker sw-avisos.js + suscripcion Web Push).
// Nada se registra hasta que alguien toca "Activar avisos": sin las claves VAPID en el servidor la app funciona igual.
import api from "@/lib/api";

const RUTA_SW = "/sw-avisos.js";

export const soportaPush = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export const permisoDeAvisos = () =>
  typeof window !== "undefined" && "Notification" in window ? window.Notification.permission : "no-soportado";

export const esIphone = () =>
  /iPhone|iPad|iPod/i.test(navigator.userAgent || "") ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

// La plataforma agregada a la pantalla de inicio (en iPhone, el unico caso en que se pueden activar los avisos).
export const esAppInstalada = () =>
  (typeof window.matchMedia === "function" && window.matchMedia("(display-mode: standalone)").matches) ||
  window.navigator.standalone === true;

function claveABytes(base64url) {
  const relleno = "=".repeat((4 - (base64url.length % 4)) % 4);
  const crudo = window.atob((base64url + relleno).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(crudo, (c) => c.charCodeAt(0));
}

function mismaClave(sub, bytes) {
  const actual = sub && sub.options && sub.options.applicationServerKey;
  if (!actual) return false;
  const a = new Uint8Array(actual);
  return a.length === bytes.length && a.every((v, i) => v === bytes[i]);
}

// La suscripcion de este navegador (sin registrar nada si todavia no hay service worker).
export async function suscripcionActual() {
  if (!soportaPush()) return null;
  const registro = await navigator.serviceWorker.getRegistration();
  return registro ? registro.pushManager.getSubscription() : null;
}

// Pide el permiso, registra sw-avisos.js, se suscribe con la clave publica y se la manda al servidor.
export async function activarAvisos(clavePublica, preferencias) {
  const permiso = window.Notification.permission === "granted" ? "granted" : await window.Notification.requestPermission();
  if (permiso !== "granted") return { ok: false, permiso };
  await navigator.serviceWorker.register(RUTA_SW);
  const registro = await navigator.serviceWorker.ready;
  const bytes = claveABytes(clavePublica);
  let sub = await registro.pushManager.getSubscription();
  if (sub && !mismaClave(sub, bytes)) {
    await sub.unsubscribe(); // quedo de otra clave del servidor: se arma de nuevo
    sub = null;
  }
  if (!sub) sub = await registro.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: bytes });
  const datos = sub.toJSON();
  await api.post("/push/suscripciones", {
    endpoint: datos.endpoint,
    claves: { p256dh: datos.keys.p256dh, auth: datos.keys.auth },
    preferencias,
  });
  return { ok: true, permiso, endpoint: datos.endpoint };
}

// Se da de baja en el servidor y se desuscribe el navegador. Un error del servidor no impide desuscribir.
export async function desactivarAvisos() {
  const sub = await suscripcionActual();
  if (!sub) return false;
  try {
    await api.delete("/push/suscripciones", { data: { endpoint: sub.endpoint } });
  } catch {
    /* si el servidor no la tiene o no responde, igual se desuscribe: el aviso que llegue despues se descarta */
  }
  await sub.unsubscribe();
  return true;
}

export async function cambiarPreferencias(endpoint, preferencias) {
  const { data } = await api.put("/push/suscripciones/preferencias", { endpoint, preferencias });
  return data;
}

// Al cerrar sesion: un celular o una computadora compartida no tiene que seguir recibiendo los avisos de otra
// persona. Se llama ANTES de /auth/logout (hace falta la sesion). Nunca lanza: un error no frena el cierre.
export async function bajaAlCerrarSesion() {
  try {
    await desactivarAvisos();
  } catch {
    /* no frena el cierre de sesion */
  }
}
